var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#C7D6FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.215 33.9996H22.785C22.3807 34.0008 21.9898 33.8548 21.6853 33.5889C21.3808 33.323 21.1834 32.9554 21.13 32.5546L20 24.2146C19.9719 24.0099 20.008 23.8014 20.1032 23.618C20.1985 23.4346 20.3482 23.2852 20.5319 23.1904C20.7155 23.0955 20.924 23.0599 21.1287 23.0884C21.3334 23.117 21.5243 23.2082 21.675 23.3496L23.54 25.0746C23.6386 25.1699 23.7557 25.2439 23.8841 25.292C24.0124 25.3401 24.1494 25.3613 24.2863 25.3543C24.4232 25.3473 24.5572 25.3122 24.68 25.2511C24.8028 25.1901 24.9117 25.1045 25 24.9996L27.23 22.3696C27.3238 22.2581 27.441 22.1685 27.5731 22.107C27.7052 22.0455 27.8492 22.0137 27.995 22.0137C28.1407 22.0137 28.2847 22.0455 28.4169 22.107C28.549 22.1685 28.6661 22.2581 28.76 22.3696L31 24.9996C31.0875 25.1029 31.195 25.1873 31.316 25.2478C31.4371 25.3083 31.5692 25.3436 31.7043 25.3515C31.8394 25.3595 31.9747 25.3399 32.102 25.2941C32.2293 25.2482 32.346 25.1769 32.445 25.0846L34.31 23.3596C34.4592 23.2134 34.6505 23.1175 34.8571 23.0856C35.0636 23.0536 35.2749 23.0872 35.4614 23.1815C35.6478 23.2759 35.8001 23.4262 35.8967 23.6115C35.9933 23.7968 36.0294 24.0078 36 24.2146L34.87 32.5496C34.8177 32.9513 34.6208 33.3201 34.3161 33.587C34.0115 33.8539 33.62 34.0006 33.215 33.9996Z",
    fill: "#282B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProplan);
export default __webpack_public_path__ + "static/media/proplan.5ee9b1dd3f1766d0c62b6fce536d86b8.svg";
export { ForwardRef as ReactComponent };